import { baseApi } from './BaseService';
import type { DecisionQuery, Decisions, DecisionPartitions } from '../responseTypes/authorizationDecisions';
export const authorizationDecisionsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getAuthorizationDecisions: build.query<Decisions, DecisionQuery>({
      query: params => ({ url: 'admin/authorization-decisions', params }),
    }),
    getAuthorizationPartitions: build.query<DecisionPartitions, void>({
      query: () => ({ url: 'admin/authorization-decisions/partitions' }),
    }),
  }),
});
